const GRECAPTCHA_SITE_KEY = process.env.RAZZLE_GRECAPTCHA;

export const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
        if (!GRECAPTCHA_SITE_KEY) {
            reject(new Error('reCAPTCHA site key is not configured'));
            return;
        }
        if (!window.grecaptcha) {
            reject(new Error('reCAPTCHA not loaded'));
            return;
        }
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(GRECAPTCHA_SITE_KEY, {action: 'submit'})
                .then((token) => {
                    resolve(token);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    });
};

